<template>
  <div class="offer-description">
    <h4 class="description-title">
      Opis
    </h4>
    <p class="description-content">
      Vocale to firma z branży technologicznej (software house),
      która stworzyła system dedykowany zespołom muzycznym.

      Poszukujemy pewnych siebie, komunikatywnych i pełnych energii kandydatów
      zainteresowanych rozwojem w sprzedaży produktu IT.
    </p>
    <h4 class="description-title">
      Jak będzie wyglądać moja praca?
    </h4>
    <p class="description-content">
      Będziesz kontaktować się z zespołami weselnymi, uczestniczyć w spotkaniach
      i pokazywać system, którym zespoły będą zachwycone.
    </p>
    <h4 class="description-title">
      Czy sobie poradzę?
    </h4>
    <p class="description-content">
      Jeśli dołączysz do naszego zespołu, to nauczymy Cię jak pomagać klientom i
      dobrze się przy tym bawić. Otrzymasz indywidualne wsparcie doświadczonego
      lidera, który przekaże Ci tajniki sprzedaży.
    </p>
    <h4 class="description-title">
      Jakich narzędzi potrzebuję?
    </h4>
    <p class="description-content">
      Jedyne czego potrzebujesz to chęci, a my dostarczymy Ci samochód do celów służbowych
      z możliwością rozszerzenia do celów prywatnych oraz służbowy numer telefonu.
    </p>
    <h4 class="description-title">
      Ile potrzebuję czasu?
    </h4>
    <p class="description-content">
      Największą skuteczność osiągniesz w godzinach popołudniowych, jednak to od Ciebie będzie
      zależało w jakich godzinach chcesz pracować, co przełoży się na wynagrodzenie.
    </p>
  </div>
</template>

<script>
export default {
  name: "CareerOffer"
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.offer-description {
  .description-title {
    color: $gold;
  }
}
</style>